import { Clock } from '@/modules/working_hours/domain/Clock';
import { ClockRepo, SaveClockOptions } from '@/modules/working_hours/domain/ClockRepo';

export interface UpdateClockCommandOptions {
  send_email_notification?: boolean;
  getCompanyDbId?: () => number | undefined;
  isAdmin?: boolean;  // Si true, aplica cambio inmediatamente. Si false, crea solicitud pendiente.
}

export class UpdateClockCommand {

  constructor(
    readonly clockRepo: ClockRepo,
    readonly screen_data: any,
    readonly options: UpdateClockCommandOptions = {}
  ) {
  }

  async execute(clock_to_update: Clock): Promise<boolean> {
    let updated_clock, justification
    let res = await this.screen_data.update_clock_popup.show(clock_to_update)
    if(res){
      let i = this.screen_data.clocks.findIndex((e) => e.uuid == clock_to_update.uuid);
      updated_clock = res.updated_clock
      justification = res.justification
      updated_clock.changes.push({timestamp:updated_clock.timestamp,type:updated_clock.type,justification})

      // Preparar opciones de guardado
      const saveOptions: SaveClockOptions = {
        is_admin_or_owner: this.options.isAdmin ?? false
      };
      if (this.options.send_email_notification) {
        saveOptions.send_email_notification = true;
        if (this.options.getCompanyDbId) {
          const companyDbId = this.options.getCompanyDbId();
          if (companyDbId) {
            saveOptions.companydb_id = companyDbId;
          }
        }
      }

      await this.clockRepo.save(updated_clock, saveOptions)

      // Funcionalidad del if else de a continuación:
      // Solo actualizar lista de peticiones en caso de sea un user admin,
      // si no, aparece un 'pendiente' y no se refresca hasta que el admin lo apruebe.
      if (this.options.isAdmin) {
        this.screen_data.clocks[i].timestamp = updated_clock.timestamp
        this.screen_data.clocks[i].type = updated_clock.type
        this.screen_data.clocks[i].changes.push({
          timestamp: updated_clock.timestamp,
          type: updated_clock.type,
          justification,
          state: 'validated'
        })
      } else {
        this.screen_data.clocks[i].changes.push({
          timestamp: updated_clock.timestamp,
          type: updated_clock.type,
          justification,
          state: 'pending'
        })
      }

      return true; 
    }

    return false;
  }
}

export class UpdateClockTodayCommand extends UpdateClockCommand {
  async execute(clock_to_update: Clock): Promise<boolean> {
    const saved = await super.execute(clock_to_update);

    if (saved) {
      const today = this.get_string_date(new Date());
      this.screen_data.clocks = this.screen_data.clocks.filter(clock =>
        this.get_string_date(clock.timestamp) === today
      );
    }

    return saved;
  }

  private get_string_date(date: Date): string {
    return date.toISOString().split("T")[0];
  }
}
